/**
 * wa.me exige el número en formato internacional sin "+". Los negocios lo cargan
 * como en Ecuador (099…, 02…): con el 0 local el link no abre ningún chat.
 * 0XXXXXXXX(X) → 593XXXXXXXX(X); con código de país (593…, +1…, 00…) se respeta.
 * Mantener igual que en faisen-store-gtw (store.service.ts).
 */
export function whatsappDigits(raw: string | undefined): string | null {
  let d = (raw || '').replace(/\D/g, '');
  if (d.startsWith('00')) d = d.slice(2);
  else if (d.startsWith('0')) d = '593' + d.slice(1);
  return d.length >= 8 ? d : null;
}

export function whatsappLink(raw: string | undefined, text?: string): string | null {
  const d = whatsappDigits(raw);
  if (!d) return null;
  return `https://wa.me/${d}${text ? '?text=' + encodeURIComponent(text) : ''}`;
}
